import { CLOSE_DIALOG, OPEN_DIALOG } from '../actions/dialogActions';

const initialState = {
  state: false,
  options: {
    children: '',
    permanent: false,
    headLight: false
  }
};

const dialogReducer = (state = initialState, action) => {
  switch (action.type) {
    case OPEN_DIALOG:
      return {
        ...state,
        state: true,
        options: {
          ...state.options,
          ...action.payload.data
        }
      };
    case CLOSE_DIALOG:
      return {
        ...state,
        state: false,
        options: initialState.options
      };
    default:
      return state;
  }
};

export default dialogReducer;



// WEBPACK FOOTER //
// ./src/redux/reducers/dialogReducer.js